import styled from 'styled-components';

export const IntroCard = styled.div`
	min-width: 700px;
	width: 700px;
	min-height: 400px;
	padding: 40px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	border-radius: 20px;
	background: #fff;
	flex-shrink: 0;
	scroll-snap-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;

	/* Entrance animation */
	animation: slideInFromRight 0.6s cubic-bezier(0.4, 0, 0.2, 1);

	@keyframes slideInFromRight {
		from {
			opacity: 0;
			transform: translateX(50px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}
`;

export const IntroTitle = styled.div`
	margin-bottom: 24px;
`;

export const IntroDescription = styled.div`
	margin-bottom: 20px;
	font-size: 1.1rem;
	line-height: 1.6;
`;

export const IntroExplanation = styled.div`
	margin-bottom: 32px;
	line-height: 1.5;
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
`;
